var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workflow-container" },
    [
      _c("div", { staticClass: "workflow-header" }, [
        _c("h1", { staticClass: "workflow-title" }, [
          _vm._v(_vm._s(_vm.$t("task.allWorkflow"))),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { display: "flex", gap: "10px" } }, [
          _c(
            "div",
            {
              staticClass: "view-toggle-btn",
              on: {
                click: function ($event) {
                  return _vm.$feature.beforeCreateTaskWorkflow(
                    _vm.createWorkflow
                  )
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("add_circle"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("task.createworkflow")))]),
            ]
          ),
          _vm._v(" "),
          !_vm.isTableView
            ? _c(
                "button",
                {
                  staticClass: "view-toggle-btn",
                  class: { "drag-active": _vm.isDragEnabled },
                  on: { click: _vm.toggleDragMode },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v(
                      _vm._s(_vm.isDragEnabled ? "check_circle" : "swap_vert")
                    ),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.isDragEnabled
                          ? _vm.$t("task.editDragActive")
                          : _vm.$t("task.editSortOrder")
                      ) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "view-toggle-btn", on: { click: _vm.toggleView } },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(_vm.isTableView ? "grid_view" : "list")),
              ]),
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.isTableView
                      ? _vm.$t("message.gridView")
                      : _vm.$t("message.tableView")
                  ) +
                  "\n            "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.isTableView
        ? _c("div", { staticClass: "table-view-container" }, [
            _c("div", { staticClass: "table-wrapper" }, [
              _c("table", { staticClass: "workflow-table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("task.workflowTitle")))]),
                    _vm._v(" "),
                    _c("th", { staticClass: "actions-column" }, [
                      _vm._v(_vm._s(_vm.$t("task.workflowActions"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.getWorkflows(), function (workflow) {
                    return _c("tr", { key: workflow._id }, [
                      _c("td", { staticClass: "title-column" }, [
                        _vm._v(_vm._s(workflow.title)),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "actions-column" }, [
                        _c("div", { staticClass: "action-buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "action-btn open",
                              on: {
                                click: function ($event) {
                                  return _vm.openWorkflow(workflow._id)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("open_in_new"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.$t("task.view")))]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.taskDetailPermission()
                            ? _c(
                                "button",
                                {
                                  staticClass: "action-btn edit",
                                  on: {
                                    click: function ($event) {
                                      return _vm.editWorkFlow(workflow._id)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("edit"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.edit"))),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.taskDetailPermission()
                            ? _c(
                                "button",
                                {
                                  staticClass: "action-btn delete",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteWorkflowFunc(workflow)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("delete"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chatbotv2.delete"))),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "grid-view-container" }, [
            _c(
              "div",
              { staticClass: "draggable-container" },
              [
                _c(
                  "draggable",
                  {
                    staticClass: "workflow-drag",
                    attrs: { disabled: !_vm.isDragEnabled },
                    on: { end: _vm.updateWorkflowsOrder },
                    model: {
                      value: _vm.localWorkflows,
                      callback: function ($$v) {
                        _vm.localWorkflows = $$v
                      },
                      expression: "localWorkflows",
                    },
                  },
                  _vm._l(_vm.localWorkflows, function (workflow) {
                    return _c(
                      "div",
                      {
                        key: workflow._id,
                        staticClass: "workflow-card",
                        class: { "drag-mode": _vm.isDragEnabled },
                        on: {
                          click: function ($event) {
                            !_vm.isDragEnabled && _vm.openWorkflow(workflow._id)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "workflow-card-content" },
                          [
                            _c("WorkflowIcon", {
                              staticClass: "workflow-icon",
                            }),
                            _vm._v(" "),
                            _c(
                              "h3",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: workflow.title,
                                      placement: "top",
                                    },
                                    expression:
                                      "{ content: workflow.title, placement: 'top' }",
                                  },
                                ],
                                staticClass: "workflow-card-title",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      workflow.title.length > 25
                                        ? workflow.title.substring(0, 25) +
                                            "..."
                                        : workflow.title
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.taskDetailPermission()
                          ? _c(
                              "div",
                              { staticClass: "workflow-card-actions" },
                              [
                                _c(
                                  "a-dropdown",
                                  {
                                    attrs: {
                                      trigger: ["click"],
                                      placement: "bottomRight",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "overlay",
                                          fn: function () {
                                            return [
                                              _c(
                                                "a-menu",
                                                [
                                                  _c(
                                                    "a-menu-item",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "5px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.editWorkFlow(
                                                            workflow._id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("edit")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.edit"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-menu-item",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "5px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.copyWorkFlowId(
                                                            workflow._id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("content_copy")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "WorkFlow ID Kopyala"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-menu-item",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "5px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deleteWorkflowFunc(
                                                            workflow
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("delete")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chatbotv2.delete"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "more-btn",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("more_horiz")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
      _vm._v(" "),
      _vm.deleteModal
        ? _c("DeleteModal", {
            attrs: {
              description: _vm.$t("task.deleteWorkflow"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.delete"),
            },
            on: {
              cancel: function ($event) {
                _vm.deleteModal = false
              },
              confirm: _vm.softDeleteWorkflow,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }